import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { useAuthStore } from '../store/auth';

/**
 * Landing point after an OAuth sign-in. The API has already set the refresh
 * cookie and redirected here; the app's bootstrap (App.tsx) exchanges that
 * cookie for a session. We just wait for the auth status to settle and route
 * onward — into the app on success, back to login on failure.
 */
export function AuthCallbackPage() {
  const status = useAuthStore((s) => s.status);
  const navigate = useNavigate();

  useEffect(() => {
    if (status === 'authenticated') {
      navigate('/', { replace: true });
    } else if (status === 'anonymous') {
      navigate('/login?error=sso_failed', { replace: true });
    }
  }, [status, navigate]);

  return (
    <Card className="flex flex-col items-center gap-4 p-8">
      <span
        className="h-6 w-6 animate-spin rounded-full border-2 border-border border-t-iris"
        aria-hidden
      />
      <p className="text-sm text-muted">Signing you in…</p>
    </Card>
  );
}
